

















import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../../shared/services/mixin";
import {Component, Prop} from "vue-property-decorator";
import {CustomerService} from "@/interfaces/entity/customerService";
import {CustomerServiceStore} from "@/modules/customerservice/store";


@Component({
    name: "CustomerServiceTableAction"
})
export default class extends mixins(CommonMixin){
    @Prop({required: true, type: Number})
    readonly customerServiceId!: number;
    
    get customerService(): CustomerService {
        return CustomerServiceStore.data[this.customerServiceId];
    }
    
    set customerService(value: CustomerService) {
        CustomerServiceStore.data[this.customerServiceId] = value;
    }
    
    async onConfirm() {
        try {
            await CustomerServiceStore.deleteCustomerService(this.customerServiceId);
            this.$notification.success({
                message: "Thành công",
                description: "Xóa thành công"
            });
        } catch (e) {
            this.$notification.error({
                message: "Thất bại",
                description: "Xóa thất bại"
            });
        }
    }
}
